import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "frisbuy-summary-widget__header" }
const _hoisted_2 = { class: "frisbuy-summary-widget__header-wrapper" }
const _hoisted_3 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "50",
  height: "50",
  viewBox: "0 0 50 50",
  fill: "none"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<path d=\"M14.1763 33.8248H10.7839L15.9529 18.8516H20.0326L25.1942 33.8248H21.8019L18.0512 22.2732H17.9343L14.1763 33.8248ZM13.9643 27.9393H21.9773V30.4105H13.9643V27.9393Z\" fill=\"#007DB7\"></path><path d=\"M30.1622 18.8516V33.8248H26.9964V18.8516H30.1622Z\" fill=\"#007DB7\"></path><path d=\"M36.7647 4.41016L37.7246 8.33329C38.2006 10.2788 39.7196 11.7978 41.6651 12.2738L45.5882 13.2337L41.6651 14.1936C39.7196 14.6696 38.2006 16.1886 37.7246 18.1341L36.7647 22.0572L35.8048 18.1341C35.3288 16.1886 33.8098 14.6696 31.8643 14.1936L27.9412 13.2337L31.8643 12.2738C33.8098 11.7978 35.3288 10.2788 35.8048 8.33329L36.7647 4.41016Z\" fill=\"#007DB7\"></path><path d=\"M43.3824 22.0586L44.1023 25.0009C44.4593 26.4601 45.5985 27.5993 47.0577 27.9563L50 28.6762L47.0577 29.3962C45.5985 29.7532 44.4593 30.8924 44.1023 32.3515L43.3824 35.2939L42.6624 32.3515C42.3054 30.8924 41.1662 29.7532 39.7071 29.3962L36.7647 28.6762L39.7071 27.9563C41.1662 27.5993 42.3054 26.4601 42.6624 25.0009L43.3824 22.0586Z\" fill=\"#007DB7\"></path><path d=\"M22.7941 12.4998H8.08536C6.46224 12.4998 5.14706 13.8154 5.14706 15.4409V36.7645C5.14706 38.3888 6.46387 39.7057 8.08823 39.7057H39.7059V42.6468H9.55882C5.88235 44.1174 5.14706 45.588 0 45.588C1.47053 44.1175 2.25465 42.6469 2.25471 37.7884C2.2718 37.8079 2.28948 37.8266 2.30641 37.8459C2.24125 37.4953 2.20588 37.134 2.20588 36.7645V15.4409C2.20588 12.1935 4.83541 9.55861 8.08536 9.55859H22.7941V12.4998Z\" fill=\"#007DB7\"></path>", 5)
const _hoisted_9 = [
  _hoisted_4
]
const _hoisted_10 = { class: "frisbuy-summary-widget__header-container" }
const _hoisted_11 = { class: "frisbuy-summary-widget__header-title" }


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderBlock',
  props: {
    text: {},
    isShowAiIcon: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isShowAiIcon)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_9))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(props.text), 1),
        _renderSlot(_ctx.$slots, "ai-3")
      ])
    ]),
    _renderSlot(_ctx.$slots, "ai-1"),
    _renderSlot(_ctx.$slots, "anchor"),
    _renderSlot(_ctx.$slots, "faq")
  ]))
}
}

})